import player from './player.vue'

export default player
